import React from 'react';
import { connect } from 'react-redux';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';

import logo from '../../../../assets/images/logo.png'; // Tell Webpack this JS file uses this image
import './styles.scss';
import { APP_TEXTS } from '../../../../texts/texts';
// import tabs from '../../../../App/tabs';
import { newProject, openProjectFile, saveProject } from '../../../../reducers/actions';
import { disclaimerContent, getCountryForDisclaimer } from '../../../../App/App';
import Popup from 'reactjs-popup';
import { brandList } from '../../../../app.values';
import { BRAND } from '@config';
import initService from '@services/requests/init.service';

const CINFO = {
  Address1: "Address1",
  Address2: "Address2",
  Address3: "Address3",
  Emails: "CountryEmails",
  BrandWebSite: "BrandWebSite",
  CountryWebSite: "CountryWebSite",
  ContactName: "ContactName",
  Phone: "Phone",
  AvailableHours: "AvailableHours",
  CatalogLink: "CatalogLink"
};

class NavBar extends React.Component {

  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false,
      displayPrivacyPolicy: false,
      displaySupport: false,
      displayAbout: false,
      databaseVersion: "",
      softwareVersion: "",
      countryInfo: {}
    };
    
    initService.getCurrentVersions().then((res) => {
      if (res && res.length) {
        this.setState({ 
          databaseVersion: res[0].RunName, 
          softwareVersion: res[1].RunName
        });
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.country !== this.props.country || JSON.stringify(this.state.countryInfo) === JSON.stringify({})) {
      initService.getCountryInfo().then((res) => {
        if (res && res.name !== 'TypeError') {
          this.setState({ countryInfo: res });
        }
      });
    }
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render() {
    // var string1 = APP_TEXTS.MENU_FILE.Content;
    return (
      <div>
        <Navbar dark expand="md">
          <NavbarBrand className="header__logo" href={this.getLogoWebsiteAddress()}>
            <img src={logo} alt="logo" />
          </NavbarBrand>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto" navbar>
              <UncontrolledDropdown nav>
                <DropdownToggle nav caret>
                  {APP_TEXTS.MENU_FILE.Content}
                </DropdownToggle>
                <DropdownMenu right={true} className="dropdown-menu dropdown-menu-right">
                  <DropdownItem onClick={this.props.new}>
                    {APP_TEXTS.MENU_FILE_NEW_PROJECT.Content}
                  </DropdownItem>
                  <DropdownItem onClick={this.props.open}>
                   { APP_TEXTS.MENU_FILE_OPEN_PROJECT.Content}
                  </DropdownItem>
                  <DropdownItem onClick={this.props.save}>
                    {APP_TEXTS.MENU_FILE_SAVE_PROJECT.Content}
                  </DropdownItem>
                  <DropdownItem divider />
                  <DropdownItem>
                    {APP_TEXTS.MENU_FILE_EXIT.Content}
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
              {/* <UncontrolledDropdown nav>
                <DropdownToggle nav caret>
                  {APP_TEXTS.MENU_OPTIONS.Content}
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem onClick={ () => { this.props.changeTab(tabs.OPTIONS);}}>
                    {APP_TEXTS.MENU_OPTIONS_COUNTRY_DESIGN_STANDARD.Content}
                  </DropdownItem>
                  <DropdownItem onClick={ () => { this.props.changeTab(tabs.OPTIONS);}}>
                    {APP_TEXTS.MENU_OPTIONS_LANGUAGE.Content}
                  </DropdownItem>
                  <DropdownItem onClick={ () => { this.props.changeTab(tabs.OPTIONS);}}>
                    {APP_TEXTS.MENU_OPTIONS_UNITS.Content}
                  </DropdownItem>
                  <DropdownItem>
                   {APP_TEXTS.MENU_OPTIONS_USER_PROFILE.Content}
                  </DropdownItem>
                  <DropdownItem>
                    {APP_TEXTS.MENU_OPTIONS_ENVIRONMENT.Content}
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown> */}
              <NavItem>
                <NavLink 
                  href={this.state.countryInfo[CINFO.CatalogLink] || "#"}
                  target="_blank" 
                  rel="noopener noreferrer">
                    {APP_TEXTS.MENU_CATALOG.Content}
                </NavLink>
              </NavItem>
              <UncontrolledDropdown nav>
                <DropdownToggle nav caret>
                 {APP_TEXTS.MENU_HELP.Content}
                </DropdownToggle>
                <DropdownMenu right={true} className="dropdown-menu dropdown-menu-right">
                  {/* <DropdownItem>
                    {APP_TEXTS.MENU_HELP.Content}
                  </DropdownItem> */}
                  <DropdownItem onClick={() => { this.setState({ displaySupport: true });}}>
                   {APP_TEXTS.MENU_HELP_SUPPORT.Content}
                  </DropdownItem>
                  {/* <DropdownItem>
                    {APP_TEXTS.MENU_HELP_WELCOME.Content}
                  </DropdownItem> */}
                  <DropdownItem onClick={() => { this.setState({ displayPrivacyPolicy: true });}}>
                   {APP_TEXTS.MENU_HELP_PRIVACY_POLICY.Content}
                  </DropdownItem>
                  <DropdownItem onClick={() => { this.setState({ displayAbout: true });}}>
                    {APP_TEXTS.MENU_HELP_ABOUT.Content}
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </Nav>
          </Collapse>
        </Navbar>
        
        <Popup // Privacy Policy
            className="default_popup"
            modal={true}
            open={this.state.displayPrivacyPolicy}
            closeOnDocumentClick={true}
            onClose={() => this.setState({ displayPrivacyPolicy: false })}
          >
          {close => disclaimerContent(() => close(), true, getCountryForDisclaimer(this.props.appStatus, this.props.country))}
        </Popup>
        
        <Popup // Support
          className="support_popup default_popup"
          modal={true}
          open={this.state.displaySupport}
          closeOnDocumentClick={false}
        >
          {close => (        
            <React.Fragment>
              <h4 className="default_popup-header mb-2 ml-2">{APP_TEXTS.MENU_HELP_SUPPORT.Content}</h4>
              <section className="list-type default_popup-text">
                <div className="content">
                  <img src={logo} alt={logo} className="logo"/><br/>
                  <div className="ml-2">
                  <p>{APP_TEXTS.SUPPORT_CONTENT.Content}</p>
                    <div className="ml-4">
                      <p>{this.state.countryInfo[CINFO.Address1]}<br/>
                      {this.state.countryInfo[CINFO.Address2]}<br/>
                      {this.state.countryInfo[CINFO.Address3]}<br/></p>

                      <p>
                        {this.state.countryInfo[CINFO.CountryWebSite] && (
                          <React.Fragment>
                            <a href={"http://" + this.state.countryInfo[CINFO.CountryWebSite]} target="_blank" rel="noopener noreferrer">
                              {this.state.countryInfo[CINFO.CountryWebSite]}
                            </a><br/>
                          </React.Fragment>
                        )}
                        {this.state.countryInfo[CINFO.BrandWebSite] && (
                          <React.Fragment>
                          <a href={"http://" + this.state.countryInfo[CINFO.BrandWebSite]} target="_blank" rel="noopener noreferrer">
                            {this.state.countryInfo[CINFO.BrandWebSite]}
                          </a><br/>
                          </React.Fragment>
                        )}
                      </p>

                      <div>
                        {APP_TEXTS.SUPPORT_TECHNICAL_SUPPORT.Content} {this.state.countryInfo[CINFO.ContactName]} <br/>
                        <div className="ml-4">
                          {APP_TEXTS.OPTIONS_PROFILE_EMAIL_ADDRESS.Content} {this.state.countryInfo[CINFO.Emails]} <br/>
                          {APP_TEXTS.OPTIONS_PROFILE_PHONE_NUMBER.Content} {this.state.countryInfo[CINFO.Phone]}  
                          {this.state.countryInfo.AvailableHours && ( 
                            <span>
                              &nbsp;({APP_TEXTS.SUPPORT_HOURS.Content} {this.state.countryInfo.AvailableHours})
                            </span>
                            )}<br/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <div className="default_popup-footer mt-2">
                <button
                  className="btn btn-sm support_popup-button default_popup-button"
                  onClick={() => {
                    this.setState({ displaySupport: false });
                    close();
                  }}
                >
                  {APP_TEXTS.ANCHOR_SELECTION_OK.Content}
                </button>
              </div>
            </React.Fragment>
          )}
        </Popup>
      
        <Popup // About
          className="about_popup default_popup"
          modal={true}
          open={this.state.displayAbout}
          closeOnDocumentClick={false}
        >
          {close => (        
            <React.Fragment>
              <h4 className="default_popup-header mb-2 ml-2">{APP_TEXTS.MENU_HELP_ABOUT.Content}</h4>
              <section className="list-type default_popup-text">
                <div className="content">
                  <section className="list-type">
                    {APP_TEXTS.ABOUT_SOFTWARE_VERSION.Content} {this.state.softwareVersion}
                  </section>
                  <section className="list-type">
                    {APP_TEXTS.ABOUT_DATABASE_VERSION.Content} {this.state.databaseVersion}
                  </section>
                  <section className="list-type">
                    {APP_TEXTS.ABOUT_TRANSLATION_DISCLAIMER.Content}
                  </section>
                  <section className="list-type">
                    {APP_TEXTS.ABOUT_DEVELOPED_WITH_GRAITEC.Content}<br/>
                    <span className="icon_logograitec"/>&nbsp;&nbsp;
                    <a href="http://www.graitec.com" target="_blank" rel="noopener noreferrer">
                      www.graitec.com
                    </a><br/>
                  </section>
                  <section className="list-type">
                    {APP_TEXTS.ABOUT_COPYRIGHT.Content}
                  </section>
                </div>
              </section>
              <div className="default_popup-footer mt-2">
                <button
                  className="btn btn-sm about_popup-button default_popup-button"
                  onClick={() => {
                    this.setState({ displayAbout: false });
                    close();
                  }}
                >
                  {APP_TEXTS.ANCHOR_SELECTION_OK.Content}
                </button>
              </div>
            </React.Fragment>
          )}
        </Popup>
      </div>
    );
  }

  getLogoWebsiteAddress() {
    switch (BRAND) {
      case brandList.Ramset: return "https://ramset.co.nz/";
      case brandList.Redhead: return "https://www.itwredhead.com/";
      case brandList.Spit: 
      default: return "https://www.spitpaslode.com/";
    }
  }

}

const mapState = (state) => ({
  appStatus: state.main.status, // VladP: just to update the translations
  country: state.main.localization.country
});

const mapDispatch = dispatch => ({
  new: () => dispatch(newProject()),
  save: () => dispatch(saveProject()),
  open: () => dispatch(openProjectFile())
});

export default connect(
  mapState,
  mapDispatch
)(NavBar);



// WEBPACK FOOTER //
// ./src/components/Header/components/NavBar/index.js